import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/will/Documents/Business/wise/repos/wise/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/home/will/Documents/Business/wise/repos/wise/site/themes/saliant/components/Header.tsx");
